// #region HTML Ids & Classnames

export const ERROR_NOTIFICATION_ROOT_CONTAINER = 'error-notification';
export const LOADING_INDICATOR_CONTAINER = 'loading-container';
export const IMAGE_HEADER_CONTAINER_ID = 'image-header-container';
export const APP_CONTAINER_ID = 'family-card-tariffs';
export const TARIFF_CARD_CONTAINER_ID = 'family-card-tariff-card';
export const ERROR_NOTIFICATION_CONTAINER_ID = 'family-card-error-notification';
export const CASHBACK_PROMOTIONAL_CARD_CONTAINER = 'cashback-promotional-card';

// #endregion
